module.exports = __webpack_public_path__ + "static/media/mainbanner3.86b0704c.jpeg";